import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createSubscriptionCheckout } from '../services/api';
import { useCustomerAuth } from '../services/CustomerAuthContext';

function SubscriptionTiers() {
  const { customer } = useCustomerAuth();
  const navigate = useNavigate();

  async function handleUpgrade(tier) {
    if (!customer) {
      navigate('/customer/register');
      return;
    }
    try {
      const data = await createSubscriptionCheckout(tier);
      window.location.href = data.url;
    } catch (err) {
      alert(err.error || 'Failed to start checkout');
    }
  }

  return (
    <section className="subscription-section" id="subscribe">
      <h2 className="section-title">Membership Tiers</h2>
      <p className="section-subtitle">Not just a marketplace — a living library of how things are made.</p>
      <div className="tier-grid">
        <div className="tier-card">
          <h3>Explorer</h3>
          <p className="tier-price">Free</p>
          <ul>
            <li>Browse the Expo Floor</li>
            <li>View vendor previews</li>
            <li>See item pricing</li>
          </ul>
          <button className="btn-secondary" onClick={() => navigate('/customer/register')}>Get Started</button>
        </div>
        <div className="tier-card featured">
          <div className="tier-badge">Most Popular</div>
          <h3>Member</h3>
          <p className="tier-price">$4.99<span className="tier-period">/mo</span></p>
          <p className="tier-annual">or $3.99/mo billed annually <span className="tier-savings">Save 20%</span></p>
          <ul>
            <li>Visit vendor booths</li>
            <li>Purchase items directly</li>
            <li>Spotlight Bid access</li>
            <li>1 commission request/month</li>
            <li>Community feed</li>
          </ul>
          <button className="btn-primary" onClick={() => handleUpgrade('member')}>Upgrade</button>
        </div>
        <div className="tier-card">
          <h3>Enthusiast</h3>
          <p className="tier-price">$7.99<span className="tier-period">/mo</span></p>
          <p className="tier-annual">or $6.49/mo billed annually <span className="tier-savings">Save 19%</span></p>
          <ul>
            <li>Everything in Member</li>
            <li>Vendor livestream access</li>
            <li>Featured videos &amp; replays</li>
            <li>Webinar replays</li>
            <li>3 commission requests/month</li>
            <li>Enthusiast badge</li>
          </ul>
          <button className="btn-secondary" onClick={() => handleUpgrade('enthusiast')}>Upgrade</button>
        </div>
        <div className="tier-card">
          <h3>Insider</h3>
          <p className="tier-price">$12.99<span className="tier-period">/mo</span></p>
          <p className="tier-annual">or $10.99/mo billed annually <span className="tier-savings">Save 15%</span></p>
          <ul>
            <li>Everything in Enthusiast</li>
            <li>5 commission requests/month</li>
            <li>Early access to new drops</li>
            <li>Workshop &amp; blueprints</li>
            <li>Challenge voting</li>
            <li>Insider badge</li>
          </ul>
          <button className="btn-secondary" onClick={() => handleUpgrade('insider')}>Upgrade</button>
        </div>
      </div>
    </section>
  );
}

export default SubscriptionTiers;
